// @flow

import styled from 'styled-components';

const Container = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export default Container;
